angular.module('unergie.main')
.controller('trvCtrl', ($scope, $state, $uibModal, AlertManager, DataAccessTrv, NgTableParams, Tokens, ErrorCatcher) => {
    $scope.isActive = (state) => $state.is(state)

    const refresh = () =>
        DataAccessTrv.getTrv().$promise.then((data) => {
            data.forEach((elem) => {
                elem.cons = _.orderBy(elem.cons, 'temp_class', 'desc')
                elem.from_date = moment(elem.from_date).toDate()
            })
            $scope.tableParams = new NgTableParams({
                page: ($scope.tableParams != null ? $scope.tableParams.page() : undefined) || 1,
                count: ($scope.tableParams != null ? $scope.tableParams.count() : undefined) || 10,
                filter: ($scope.tableParams != null ? $scope.tableParams.filter() : undefined) || {},
                sorting: ($scope.tableParams != null ? $scope.tableParams.sorting() : undefined) || {},
            }, { counts: [10, 25, 50, 100], dataset: data })

            return $scope.tableParams
        }).catch(ErrorCatcher)


    $scope.refresh = refresh
    refresh()

    $scope.delete = (trv) => DataAccessTrv.delTrv({ id: trv.id }).$promise.then((data) => refresh()).catch(ErrorCatcher)


    const trvTemplate = {
        id: '',
        plan_id: '',
        abo_3: '',
        abo_6: '',
        abo_9: '',
        abo_12: '',
        abo_15: '',
        abo_18: '',
        abo_24: '',
        abo_30: '',
        abo_36: '',
        from_date: new Date(),
    }
    $scope.trvFields = {
        id: {
            label: 'Nom',
            required: true,
            type: 'text',
        },
        plan_id: {
            label: 'Base/HPHC',
            required: true,
            type: 'select',
            enum: [
                {
                    value: 10,
                    label: 'Base',
                },
                {
                    value: 20,
                    label: 'HP/HC',
                },
            ],
        },
        abo_3: {
            label: 'Abonnement 3kVA (€/an)',
            required: true,
            type: 'text',
        },
        abo_6: {
            label: 'Abonnement 6kVA (€/an)',
            required: true,
            type: 'text',
        },
        abo_9: {
            label: 'Abonnement 9kVA (€/an)',
            required: true,
            type: 'text',
        },
        abo_12: {
            label: 'Abonnement 12kVA (€/an)',
            required: true,
            type: 'text',
        },
        abo_15: {
            label: 'Abonnement 15kVA (€/an)',
            required: true,
            type: 'text',
        },
        abo_18: {
            label: 'Abonnement 18kVA (€/an)',
            required: true,
            type: 'text',
        },
        abo_24: {
            label: 'Abonnement 24kVA (€/an)',
            required: true,
            type: 'text',
        },
        abo_30: {
            label: 'Abonnement 30kVA (€/an)',
            required: true,
            type: 'text',
        },
        abo_36: {
            label: 'Abonnement 36kVA (€/an)',
            required: true,
            type: 'text',
        },
        from_date: {
            label: 'Date d\'effet',
            type: 'date',
        },
    }

    $scope.updateTrvConsFields = {
        cons_3: {
            label: 'Consommation 3kVA (€/KWh)',
            required: true,
            type: 'text',
        },
        cons_6: {
            label: 'Consommation 6kVA (€/KWh)',
            required: true,
            type: 'text',
        },
        cons_9: {
            label: 'Consommation 9kVA (€/KWh)',
            required: true,
            type: 'text',
        },
        cons_12: {
            label: 'Consommation 12kVA (€/KWh)',
            required: true,
            type: 'text',
        },
        cons_15: {
            label: 'Consommation 15kVA (€/KWh)',
            required: true,
            type: 'text',
        },
        cons_18: {
            label: 'Consommation 18kVA (€/KWh)',
            required: true,
            type: 'text',
        },
        cons_24: {
            label: 'Consommation 24kVA (€/KWh)',
            required: true,
            type: 'text',
        },
        cons_30: {
            label: 'Consommation 30kVA (€/KWh)',
            required: true,
            type: 'text',
        },
        cons_36: {
            label: 'Consommation 36kVA (€/KWh)',
            required: true,
            type: 'text',
        },
    }

    $scope.updateTrvFields = angular.copy($scope.trvFields)
    $scope.updateTrvFields.id.hidden = true
    $scope.updateTrvFields.plan_id.hidden = true

    const resetTrvPayload = () => ($scope.trvPayload = angular.copy(trvTemplate))

    resetTrvPayload()

    $scope.addTrv = () =>
        DataAccessTrv.addTrv($scope.trvPayload).$promise.then(() => {
            const cons = []
            if ($scope.trvPayload.plan_id === 10) {
                cons.push({ id_trv: $scope.trvPayload.id,
                    temp_class: 'BASE',
                    cons_3: '100%',
                    cons_6: '100%',
                    cons_9: '100%',
                    cons_12: '100%',
                    cons_15: '100%',
                    cons_18: '100%',
                    cons_24: '100%',
                    cons_30: '100%',
                    cons_36: '100%' })
            } else {
                cons.push({ id_trv: $scope.trvPayload.id,
                    temp_class: 'HP',
                    cons_3: '100%',
                    cons_6: '100%',
                    cons_9: '100%',
                    cons_12: '100%',
                    cons_15: '100%',
                    cons_18: '100%',
                    cons_24: '100%',
                    cons_30: '100%',
                    cons_36: '100%' })
                cons.push({ id_trv: $scope.trvPayload.id,
                    temp_class: 'HC',
                    cons_3: '100%',
                    cons_6: '100%',
                    cons_9: '100%',
                    cons_12: '100%',
                    cons_15: '100%',
                    cons_18: '100%',
                    cons_24: '100%',
                    cons_30: '100%',
                    cons_36: '100%' })
            }
            return DataAccessTrv.addTrvCons(cons).$promise.then(() => {
                AlertManager.success('Offre  ajoutée')
                resetTrvPayload()
                return refresh()
            }) }).catch(ErrorCatcher)


    $scope.updateTrv = function (trv) {
        const trvPayload = angular.copy(trv)
        delete trvPayload.id
        delete trvPayload.cons
        return DataAccessTrv.updateTrv({ id: trv.id }, trvPayload).$promise.then(() => {
            AlertManager.success('Offre modifiée')
            return refresh() }).catch(ErrorCatcher)
    }

    $scope.deleteTrv = (trv) =>
        DataAccessTrv.delTrv({ id: trv.id }).$promise.then(() => {
            AlertManager.success('Offre supprimée')
            return refresh() }).catch(ErrorCatcher)


    $scope.updateTrvCons = function (trv) {
        const trvPayload = angular.copy(trv)
        delete trvPayload.id
        return DataAccessTrv.updateTrvCons({ id: trv.id }, trvPayload).$promise.then(() => {
            AlertManager.success('Offre modifiée')
            return refresh() }).catch(ErrorCatcher)
    }
})
